import styled from 'styled-components'

export const UserKeyWrapper = styled.div`
  width: 100%;
  cursor: pointer;
`

export const UserKeySelectorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 7px;
  align-items: center;
`

export const UserKeyHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const UserKeyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const UserKeyTitle = styled.div`
  font-size: 17px;
  font-weight: 400;
`

export const UserKeyBody = styled.div``

export const UserKeyBottomBorder = styled.div`
  width: 100%;
  height: 1px;
  background-color: #000;
  opacity: 0.1;
`
